import React, { useState, useMemo } from "react";
import {
  Button,
  Card,
  CardBody,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Table,
  Modal,
  ModalBody,
} from "reactstrap";
import Select from "components/Select";
import DollarInput from "../DollarInput";
import PercentageInput from "../PercentageInput";
import StatesInput from "components/StatesInput";
import { useUpdateSalesLocation } from "../../api/sales-locations/service";
import { useUpdateTaxAndFee, useDeleteTaxAndFee } from "../../api/tenant/service";
import { toNumber, formatPriceWithDollar } from "utils/currency";
import { getActiveColorStyle } from "utils/colorUtils";
import { getTheme2FormPageDarkSelectStyles } from "utils/theme2MultiSelect";

const TAX_VARIABLE_OPTIONS = [
  { value: "Flat Tax - No Tax Variable", label: "Flat Tax - No Tax Variable" },
  { value: "SalesPrice", label: "SalesPrice" },
  { value: "Document Fee", label: "Document Fee" },
  { value: "Service Contract", label: "Service Contract" },
  { value: "SalesPrice - TradeIn", label: "SalesPrice - TradeIn" },
  { value: "SalesPrice + Document Fee - TradeIn", label: "SalesPrice + Document Fee - TradeIn" },
  { value: "SalesPrice + Document Fee + Service Contract - TradeIn", label: "SalesPrice + Document Fee + Service Contract - TradeIn" },
  { value: "SalesPrice + Document Fee", label: "SalesPrice + Document Fee" },
  { value: "SalesPrice + Document Fee + Business Tax - TradeIn", label: "SalesPrice + Document Fee + Business Tax - TradeIn" },
  { value: "SalesPrice - TradeIn - DealerRebate", label: "SalesPrice - TradeIn - DealerRebate" },
  { value: "SalesPrice + Service Contract - TradeIn", label: "SalesPrice + Service Contract - TradeIn" },
  { value: "SalesPrice + Document Fee + Service Contract + TotalOtherFees", label: "SalesPrice + Document Fee + Service Contract + TotalOtherFees" },
  { value: "SalesPrice + Service Contract - TradeIn - DealerRebate", label: "SalesPrice + Service Contract - TradeIn - DealerRebate" },
  { value: "SalesPrice + Document Fee - DealerRebate", label: "SalesPrice + Document Fee - DealerRebate" },
  { value: "SalesPrice + Document Fee + Business Tax + Service Contract - TradeIn", label: "SalesPrice + Document Fee + Business Tax + Service Contract - TradeIn" },
  { value: "Amount Financed (Doc Stamp Only)", label: "Amount Financed (Doc Stamp Only)" },
  { value: "SalesPrice + Service Contract + GAP - TradeIn - ManfRebate", label: "SalesPrice + Service Contract + GAP - TradeIn - ManfRebate" },
  { value: "SalesPrice + Document Fee + Service Contract + GAP", label: "SalesPrice + Document Fee + Service Contract + GAP" },
  { value: "SalesPrice + DocFee + TheftDevice + SurfaceProtection + PollutionControlFee", label: "SalesPrice + DocFee + TheftDevice + SurfaceProtection + PollutionControlFee" },
  { value: "SalesPrice + Pre-Delivery + Service Contract - Trade In", label: "SalesPrice + Pre-Delivery + Service Contract - Trade In" },
  { value: "SalesPrice + Document Fee + Service Contract + GAP - TradeIn", label: "SalesPrice + Document Fee + Service Contract + GAP - TradeIn" },
  { value: "SalesPrice + Document Fee + Service Contract + GAP + TotalOtherFees", label: "SalesPrice + Document Fee + Service Contract + GAP + TotalOtherFees" },
  { value: "SalesPrice + Document Fee + InspectionFee", label: "SalesPrice + Document Fee + InspectionFee" },
  { value: "SalesPrice + TotalFees + Service Contract - TradeIn", label: "SalesPrice + TotalFees + Service Contract - TradeIn" },
  { value: "SalesPrice + Pre-Delivery - Trade In", label: "SalesPrice + Pre-Delivery - Trade In" },
  { value: "SalesPrice + Document Fee + InspectionFee - Trade In", label: "SalesPrice + Document Fee + InspectionFee - Trade In" },
  { value: "SalesPrice + Document Fee + Pre-Delivery - Trade In", label: "SalesPrice + Document Fee + Pre-Delivery - Trade In" },
  { value: "SalesPrice + Document Fee + Pre-Delivery", label: "SalesPrice + Document Fee + Pre-Delivery" },
  { value: "SalesPrice - TradeIn - ManfRebate", label: "SalesPrice - TradeIn - ManfRebate" },
  { value: "SalesPrice + Pre-Delivery + Document Fee + Service Contract + GAP - TradeIn", label: "SalesPrice + Pre-Delivery + Document Fee + Service Contract + GAP - TradeIn" },
  { value: "TheftDeterrent", label: "TheftDeterrent" },
  { value: "SalesPrice + DocumentFee + TheftDeterrent - TradeIn", label: "SalesPrice + DocumentFee + TheftDeterrent - TradeIn" },
  { value: "SalesPrice + Pre-Delivery + Service Contract + Electronic Filing Fee - Trade In", label: "SalesPrice + Pre-Delivery + Service Contract + Electronic Filing Fee - Trade In" },
  { value: "SalesPrice + DocumentFee + Electronic Filing Fee - Trade In", label: "SalesPrice + DocumentFee + Electronic Filing Fee - Trade In" },
  { value: "SalesPrice + Document Fee - TradeIn 1 Only", label: "SalesPrice + Document Fee - TradeIn 1 Only" },
  { value: "SalesPrice + Document Fee + Electronic Filing Fee + Service Contract - TradeIn", label: "SalesPrice + Document Fee + Electronic Filing Fee + Service Contract - TradeIn" },
  { value: "SalesPrice + TheftDeterrent - TradeIn", label: "SalesPrice + TheftDeterrent - TradeIn" },
  { value: "SalesPrice + Pre-Delivery + Service Contract + GAP + EFiling Fee - Trade In", label: "SalesPrice + Pre-Delivery + Service Contract + GAP + EFiling Fee - Trade In" },
  { value: "Gap", label: "Gap" },
  { value: "SalesPrice + DocumentFee + TheftDeterrent", label: "SalesPrice + DocumentFee + TheftDeterrent" },
  { value: "SalesPrice + Gap", label: "SalesPrice + Gap" },
  { value: "SalesPrice + DocumentFee + InspectionFee + Electronic FilingFee - TradeIn", label: "SalesPrice + DocumentFee + InspectionFee + Electronic FilingFee - TradeIn" },
  { value: "Web - GA Ad Valorem Tax Call", label: "Web - GA Ad Valorem Tax Call" },
  { value: "SalesPrice + Service Contract + GAP + InspectionFee - Trade In", label: "SalesPrice + Service Contract + GAP + InspectionFee - Trade In" },
  { value: "SalesPrice + InspectionFee", label: "SalesPrice + InspectionFee" },
  { value: "SalesPrice + DocumentFee + LicenseFee - TradeIn", label: "SalesPrice + DocumentFee + LicenseFee - TradeIn" },
  { value: "SalesPrice + ServiceContract + TheftDeterrent + Warranty - TradeIn", label: "SalesPrice + ServiceContract + TheftDeterrent + Warranty - TradeIn" },
  { value: "SalesPrice + FreightCharge + DocumentFee + Service Contract + GAP - TradeIn", label: "SalesPrice + FreightCharge + DocumentFee + Service Contract + GAP - TradeIn" },
  { value: "SalesPrice + DocumentFee + Service Contract + GAP + TheftDeterrent - TradeIn", label: "SalesPrice + DocumentFee + Service Contract + GAP + TheftDeterrent - TradeIn" },
  { value: "SalesPrice + FreightCharge + DocumentFee - TradeIn", label: "SalesPrice + FreightCharge + DocumentFee - TradeIn" },
  { value: "Smog Certification Fee", label: "Smog Certification Fee" },
  { value: "Smog Exemption Fee", label: "Smog Exemption Fee" },
  { value: "Credit Life", label: "Credit Life" },
  { value: "Credit Disability", label: "Credit Disability" },
  { value: "Unemployment Ins", label: "Unemployment Ins" },
  { value: "Property Insurance", label: "Property Insurance" },
  { value: "Optional VSI", label: "Optional VSI" },
  { value: "Road Hazard", label: "Road Hazard" },
  { value: "Service Contract", label: "Service Contract" },
  { value: "Debt Cancellation", label: "Debt Cancellation" },
  { value: "Tire and Wheel", label: "Tire and Wheel" },
  { value: "GPS", label: "GPS" },
  { value: "Surface Protection", label: "Surface Protection" },
  { value: "Window Etch", label: "Window Etch" },
  { value: "Maintenance", label: "Maintenance" },
  { value: "Limited Warranty", label: "Limited Warranty" },
  { value: "Rust Proofing", label: "Rust Proofing" },
  { value: "Dent And Ding", label: "Dent And Ding" },
  { value: "Roadside Assistance", label: "Roadside Assistance" },
  { value: "Windshield Protection", label: "Windshield Protection" },
  { value: "Key Replacement", label: "Key Replacement" },
  { value: "Service Fee", label: "Service Fee" },
  { value: "Transportation Fee", label: "Transportation Fee" },
  { value: "FL Doc Stamp Tax", label: "FL Doc Stamp Tax" },
  { value: "SalesPrice + DocumentFee + Electronic Filing Fee", label: "SalesPrice + DocumentFee + Electronic Filing Fee" },
  { value: "Inspection Fee", label: "Inspection Fee" },
  { value: "Dealer Rebate", label: "Dealer Rebate" },
  { value: "Theft Device", label: "Theft Device" },
  { value: "Pollution Control Fee", label: "Pollution Control Fee" },
  { value: "Freight Charge", label: "Freight Charge" },
  { value: "Electronic Filing Fee", label: "Electronic Filing Fee" },
  { value: "PreDelivery Fee", label: "PreDelivery Fee" },
  { value: "Property Assessment Fee", label: "Property Assessment Fee" },
  { value: "Temporary Permit Fee", label: "Temporary Permit Fee" },
  { value: "Lien Fee", label: "Lien Fee" },
  { value: "Dealer Admin Fee", label: "Dealer Admin Fee" },
  { value: "Trauma Care Fee", label: "Trauma Care Fee" },
  { value: "Mail-In Filing Fee", label: "Mail-In Filing Fee" },
  { value: "Carrier Class Fee", label: "Carrier Class Fee" },
  { value: "Messenger Fee", label: "Messenger Fee" },
  { value: "Notary Fee", label: "Notary Fee" },
  { value: "County Local Use Fee", label: "County Local Use Fee" },
  { value: "Wheelage Tax", label: "Wheelage Tax" },
  { value: "Public Safety Vehicle Fee", label: "Public Safety Vehicle Fee" },
  { value: "Transfer Tax", label: "Transfer Tax" },
  { value: "Filing Fee", label: "Filing Fee" },
  { value: "Transit Tax", label: "Transit Tax" },
  { value: "Private Tag Agency Fee", label: "Private Tag Agency Fee" },
  { value: "Uninsured Motorist Fee", label: "Uninsured Motorist Fee" },
  { value: "Convenience Fee", label: "Convenience Fee" },
  { value: "Drivers Education Fee", label: "Drivers Education Fee" },
  { value: "Supplemental Title Fee", label: "Supplemental Title Fee" },
  { value: "Dealer Reassignment Fee", label: "Dealer Reassignment Fee" },
  { value: "Registration Fee", label: "Registration Fee" },
  { value: "State Admin Fee", label: "State Admin Fee" }
];

const SellerTaxes = ({
  formData,
  setFormData,
  state,
  activeColor = "blue",
  isTheme2 = false,
  activeColorStyle: activeColorStyleProp,
  customSelectStyles,
  salesLocationId,
}) => {
  const activeColorStyle = useMemo(
    () => activeColorStyleProp || getActiveColorStyle(activeColor),
    [activeColorStyleProp, activeColor]
  );
  const selectStyles = useMemo(
    () =>
      customSelectStyles ||
      getTheme2FormPageDarkSelectStyles(activeColorStyle, isTheme2),
    [customSelectStyles, activeColorStyle, isTheme2]
  );
  // Safety check - if formData is undefined, provide default values
  const safeFormData = formData || {};
  const updateSalesLocationMutation = useUpdateSalesLocation();
  const updateTaxAndFeeMutation = useUpdateTaxAndFee({
    onClose: () => { },
    type: "Seller Tax",
  });
  const deleteTaxAndFeeMutation = useDeleteTaxAndFee();

  // Function to update sales location with seller taxes data
  const updateSalesLocation = (updatedData) => {
    if (salesLocationId) {
      updateSalesLocationMutation.mutate({
        id: salesLocationId,
        data: updatedData,
      });
    }
  };

  const [showSellerTaxForm, setShowSellerTaxForm] = useState(false);
  const [currentSellerTax, setCurrentSellerTax] = useState({
    state: state ? { id: state.id, abbreviation: state.abbreviation } : null,
    calc_type: "",
    category: "",
    amount: "$0.00",
    fixed: false,
    can_edit_at_time_of_sale: false,

    description: "",
    tax_variable: "Flat Tax - No Tax Variable",
    beginning_range: "$0.00",
    end_range: "",
    indicator: "",
    tax_rate: "0",
  });
  const [editingSellerTaxIndex, setEditingSellerTaxIndex] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedDeleteIndex, setSelectedDeleteIndex] = useState(null);

  const handleAddSellerTax = () => {
    let updatedTaxes;
    const apiTaxData = {
      ...currentSellerTax,
      amount: toNumber(currentSellerTax.amount),
      beginning_range: currentSellerTax.fixed ? 0 : toNumber(currentSellerTax.beginning_range),
      end_range: currentSellerTax.fixed ? 999999.99 : toNumber(currentSellerTax.end_range),
      tax_rate: toNumber(currentSellerTax.tax_rate),
      fee_type: currentSellerTax.calc_type === 'registration' || currentSellerTax.calc_type === 'Registration State' ? 'registration' : 'contract',
      type: "fee-contract",
    };

    if (editingSellerTaxIndex !== null) {
      updatedTaxes = [...(safeFormData.taxes || [])];
      updatedTaxes[editingSellerTaxIndex] = currentSellerTax;
      setEditingSellerTaxIndex(null);
      setFormData((prev) => ({ ...prev, taxes: updatedTaxes }));

      if (currentSellerTax.id) {
        updateTaxAndFeeMutation.mutate({
          id: currentSellerTax.id,
          data: apiTaxData,
        });
      } else {
        updateSalesLocation({ taxes: apiTaxData });
      }
    } else {
      updatedTaxes = [...(safeFormData.taxes || []), currentSellerTax];
      setFormData((prev) => ({ ...prev, taxes: updatedTaxes }));
      updateSalesLocation({ taxes: apiTaxData });
    }

    setCurrentSellerTax({
      state: state ? { id: state.id, abbreviation: state.abbreviation } : null,
      calc_type: "",
      category: "",
      amount: "$0.00",
      fixed: false,
      can_edit_at_time_of_sale: false,
      description: "",
      tax_variable: "Flat Tax - No Tax Variable",
      beginning_range: "$0.00",
      end_range: "",
      indicator: "",
      tax_rate: "0",
    });
    setShowSellerTaxForm(false);
  };

  const handleEditSellerTax = (index) => {
    if (editingSellerTaxIndex === index) {
      // If clicking on same row, close the edit form
      setEditingSellerTaxIndex(null);
      setCurrentSellerTax({
        state: state ? { id: state.id, abbreviation: state.abbreviation } : null,
        calc_type: "",
        category: "",
        amount: "$0.00",
        fixed: false,
        can_edit_at_time_of_sale: false,

        description: "",
        tax_variable: "Flat Tax - No Tax Variable",
        beginning_range: "$0.00",
        end_range: "",
        indicator: "",
        tax_rate: "0",
      });
    } else {
      // Open edit form for clicked row
      setCurrentSellerTax((safeFormData.taxes || [])[index]);
      setEditingSellerTaxIndex(index);
    }
    setShowSellerTaxForm(false); // Close top form if open
  };

  const handleDeleteClick = (index) => {
    setSelectedDeleteIndex(index);
    setDeleteModalOpen(true);
  };

  const handleConfirmDelete = () => {
    if (selectedDeleteIndex !== null) {
      const deletedTax = (safeFormData.taxes || [])[selectedDeleteIndex];
      const updatedTaxes = (safeFormData.taxes || []).filter(
        (_, i) => i !== selectedDeleteIndex
      );
      setFormData((prev) => ({ ...prev, taxes: updatedTaxes }));

      if (deletedTax && (deletedTax.id || deletedTax.documentId)) {
        deleteTaxAndFeeMutation.mutate(deletedTax.id ?? deletedTax.documentId);
      } else if (deletedTax) {
        const apiDeleteData = {
          ...deletedTax,
          amount: toNumber(deletedTax.amount),
          beginning_range: deletedTax.fixed
            ? 0
            : toNumber(deletedTax.beginning_range),
          end_range: deletedTax.fixed
            ? 999999.99
            : toNumber(deletedTax.end_range),
          tax_rate: toNumber(deletedTax.tax_rate),
          is_deleted: true,
        };
        updateSalesLocation({
          taxes: apiDeleteData,
        });
      }

      setDeleteModalOpen(false);
      setSelectedDeleteIndex(null);
    }
  };

  const handleCancelDelete = () => {
    setDeleteModalOpen(false);
    setSelectedDeleteIndex(null);
  };

  const handleCancelSellerTax = () => {
    setCurrentSellerTax({
      state: state ? { id: state.id, abbreviation: state.abbreviation } : null,
      calc_type: "",
      category: "",
      amount: "$0.00",
      fixed: false,
      can_edit_at_time_of_sale: false,

      description: "",
      tax_variable: "Flat Tax - No Tax Variable",
      beginning_range: "$0.00",
      end_range: "",
      indicator: "",
      tax_rate: "0",
    });
    setEditingSellerTaxIndex(null);
    setShowSellerTaxForm(false);
  };

  return (
    <div className="">
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        {!showSellerTaxForm && (
          <Button
            size="sm"
            style={{ ...activeColorStyle, color: "white" }}
            onClick={() => {
              setEditingSellerTaxIndex(null); // Close any open edit form
              setShowSellerTaxForm(true);
            }}
          >
            Add Tax
          </Button>
        )}
      </div>

      {showSellerTaxForm && (
        <>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label className="form-control-label">Calc Type:</Label>
                <Select
                  activeColor={activeColor}
                  styles={selectStyles}
                  className="react-select"
                  name="category"
                  value={
                    currentSellerTax.calc_type
                      ? {
                        value: currentSellerTax.calc_type,
                        label: currentSellerTax.calc_type === 'registration' ? "Registration State" : "Contract State",
                      }
                      : null
                  }
                  onChange={(option) =>
                    setCurrentSellerTax((prev) => ({
                      ...prev,
                      calc_type: option?.value || "",
                    }))
                  }
                  options={[
                    { value: "registration", label: "Registration State" },
                    { value: "contract", label: "Contract State" },
                  ]}
                  placeholder="Select"
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label className="form-control-label">Tax Category:</Label>
                <Select
                  activeColor={activeColor}
                  styles={selectStyles}
                  className="react-select"
                  name="category"
                  value={
                    currentSellerTax.category
                      ? {
                        value: currentSellerTax.category,
                        label: currentSellerTax.category,
                      }
                      : null
                  }
                  onChange={(option) =>
                    setCurrentSellerTax((prev) => ({
                      ...prev,
                      category: option?.value || "",
                    }))
                  }
                  options={[
                    { value: "State Sales Tax", label: "State Sales Tax" },
                    { value: "County Sales Tax", label: "County Sales Tax" },
                    { value: "Inventory Tax", label: "Inventory Tax" },
                    { value: "City Sales Tax", label: "City Sales Tax" },
                  ]}
                  placeholder="Select"
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <FormGroup>
                {(!currentSellerTax.tax_variable || currentSellerTax.tax_variable === "0" || currentSellerTax.tax_variable === "Flat Tax - No Tax Variable") ? (
                  <>
                    <Label className="form-control-label">Flat Tax Amount:</Label>
                    <DollarInput
                      value={currentSellerTax.amount}
                      onChange={(value) =>
                        setCurrentSellerTax((prev) => ({
                          ...prev,
                          amount: value,
                        }))
                      }
                      placeholder="$0.00"
                    />
                  </>
                ) : (
                  <>
                    <Label className="form-control-label">Rate:</Label>
                    <PercentageInput
                      name="tax_rate"
                      value={currentSellerTax.tax_rate}
                      onChange={(value) =>
                        setCurrentSellerTax((prev) => ({
                          ...prev,
                          tax_rate: value,
                        }))
                      }
                      placeholder="0.0000000%"
                      maxValue={100}
                    />
                  </>
                )}
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label className="form-control-label">Tax State:</Label>
                <StatesInput
                  name="tax_state"
                  activeColor={activeColor}
                  styles={selectStyles}
                  className="react-select"
                  value={currentSellerTax.state}
                  onChange={(stateObject) => {
                    setCurrentSellerTax((prev) => ({
                      ...prev,
                      state: stateObject
                        ? {
                          id: stateObject.id,
                          abbreviation: stateObject.abbreviation,
                        }
                        : null,
                    }));
                  }}
                  placeholder="Select State"
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label className="form-control-label">Tax Description:</Label>
                <Input
                  type="text"
                  value={currentSellerTax.description}
                  onChange={(e) =>
                    setCurrentSellerTax((prev) => ({
                      ...prev,
                      description: e.target.value,
                    }))
                  }
                  placeholder="Enter tax description"
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label className="form-control-label">Tax Variable:</Label>
                <Select
                  activeColor={activeColor}
                  styles={selectStyles}
                  className="react-select"
                  name="tax_variable"
                  value={
                    currentSellerTax.tax_variable
                      ? {
                        value: currentSellerTax.tax_variable,
                        label: currentSellerTax.tax_variable,
                      }
                      : { value: "Flat Tax - No Tax Variable", label: "Flat Tax - No Tax Variable" }
                  }
                  onChange={(option) =>
                    setCurrentSellerTax((prev) => ({
                      ...prev,
                      tax_variable: option?.value || "Flat Tax - No Tax Variable",
                    }))
                  }
                  options={TAX_VARIABLE_OPTIONS}
                  placeholder="Select"
                  isClearable={false}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row></Row>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label className="form-control-label">Tax Fixed:</Label>
                <Select
                  activeColor={activeColor}
                  styles={selectStyles}
                  className="react-select"
                  name="fixed"
                  value={
                    currentSellerTax.fixed !== null
                      ? {
                        value: currentSellerTax.fixed,
                        label: currentSellerTax.fixed ? "Yes" : "No",
                      }
                      : null
                  }
                  onChange={(option) =>
                    setCurrentSellerTax((prev) => ({
                      ...prev,
                      fixed: option?.value ?? false,
                    }))
                  }
                  options={[
                    { value: false, label: "No" },
                    { value: true, label: "Yes" },
                  ]}
                  placeholder="Select"
                  isClearable={false}
                />
              </FormGroup>
            </Col>

            <Col md="6">
              <FormGroup>
                <Label className="form-control-label">Tax Range:</Label>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <DollarInput
                    value={
                      currentSellerTax.fixed
                        ? "$0.00"
                        : currentSellerTax.beginning_range
                    }
                    onChange={(value) =>
                      setCurrentSellerTax((prev) => ({
                        ...prev,
                        beginning_range: value,
                      }))
                    }
                    placeholder="$0.00"
                    disabled={currentSellerTax.fixed}
                  />
                  <span>To</span>
                  <DollarInput
                    value={
                      currentSellerTax.fixed
                        ? "$999,999.99"
                        : currentSellerTax.end_range
                    }
                    onChange={(value) =>
                      setCurrentSellerTax((prev) => ({
                        ...prev,
                        end_range: value,
                      }))
                    }
                    placeholder="$0.00"
                    disabled={currentSellerTax.fixed}
                  />
                </div>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label className="form-control-label">
                  Can Edit At Time Of Sale?:
                </Label>
                <Select
                  activeColor={activeColor}
                  styles={selectStyles}
                  value={
                    currentSellerTax.can_edit_at_time_of_sale !== null
                      ? {
                        value: currentSellerTax.can_edit_at_time_of_sale,
                        label: currentSellerTax.can_edit_at_time_of_sale
                          ? "Yes"
                          : "No",
                      }
                      : null
                  }
                  onChange={(option) =>
                    setCurrentSellerTax((prev) => ({
                      ...prev,
                      can_edit_at_time_of_sale: option?.value ?? false,
                    }))
                  }
                  options={[
                    { value: false, label: "No" },
                    { value: true, label: "Yes" },
                  ]}
                  placeholder="Select"
                  isDisabled={currentSellerTax.indicator === "dynamic"}
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label className="form-control-label">Rate Indicator:</Label>
                <Select
                  activeColor={activeColor}
                  styles={selectStyles}
                  className="react-select"
                  name="indicator"
                  value={
                    currentSellerTax.indicator
                      ? {
                        value: currentSellerTax.indicator,
                        label: currentSellerTax.indicator,
                      }
                      : null
                  }
                  onChange={(option) =>
                    setCurrentSellerTax((prev) => ({
                      ...prev,
                      indicator: option?.value || "",
                    }))
                  }
                  options={[
                    { value: "fixed", label: "Fixed" },
                    { value: "dynamic", label: "Dynamic" },
                  ]}
                  placeholder="Select"
                />
              </FormGroup>
            </Col>
          </Row>
          {currentSellerTax.indicator === "fixed" && (
            <>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label className="form-control-label">Tax Rate:</Label>
                    <PercentageInput
                      name="tax_rate"
                      value={currentSellerTax.tax_rate}
                      onChange={(value) =>
                        setCurrentSellerTax((prev) => ({
                          ...prev,
                          tax_rate: value,
                        }))
                      }
                      placeholder="0.0000000%"
                      maxValue={100}
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label className="form-control-label">
                      Flat Tax Amount:
                    </Label>
                    <DollarInput
                      value={currentSellerTax.amount}
                      onChange={(value) =>
                        setCurrentSellerTax((prev) => ({
                          ...prev,
                          amount: value,
                        }))
                      }
                      placeholder="$0.00"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </>
          )}
          <Row>
            <Col className="text-right">
              <Button
                color="secondary"
                size="sm"
                onClick={handleCancelSellerTax}
                style={{ marginRight: "10px" }}
              >
                Cancel
              </Button>
              <Button
                size="sm"
                style={{ ...activeColorStyle, color: "white" }}
                onClick={handleAddSellerTax}
              >
                {editingSellerTaxIndex !== null ? "Update" : "Add"}
              </Button>
            </Col>
          </Row>
        </>
      )}

      {safeFormData.taxes?.length === 0 ? (
        <div style={{ textAlign: "center", padding: "20px", color: "#999" }}>
          No taxes added yet
        </div>
      ) : (
        <Table responsive>
          <thead className="text-primary">
            <tr>
              <th>State</th>
              <th>Category</th>
              <th>Description</th>
              <th>Rate</th>
              <th>Taxable/Variable</th>
              <th>Fixed Rate</th>
              <th>Beg Range</th>
              <th>End Range</th>
              <th>Edit At Time of Sale</th>
              <th className="text-right"></th>
            </tr>
          </thead>
          <tbody>
            {safeFormData.taxes?.map((tax, idx) => (
              <React.Fragment key={idx}>
                <tr onClick={() => handleEditSellerTax(idx)}>
                  <td>{tax.state?.abbreviation}</td>
                  <td>{tax.category}</td>
                  <td>{tax.description}</td>
                  <td>{tax.tax_rate + "%"}</td>
                  <td>{tax.tax_variable ? "Variable" : "Taxable"}</td>
                  <td>{tax.fixed ? "True" : "False"}</td>
                  <td>{formatPriceWithDollar(tax.beginning_range)}</td>
                  <td>{formatPriceWithDollar(tax.end_range)}</td>
                  <td>{tax.can_edit_at_time_of_sale ? "True" : "False"}</td>
                  <td className="text-right">
                    <div className="actions-right">
                      <Button
                        color="warning"
                        size="sm"
                        className="btn-icon btn-link like"
                        onClick={() => handleEditSellerTax(idx)}
                      >
                        <i className="tim-icons icon-pencil" />
                      </Button>
                      <Button
                        color="danger"
                        size="sm"
                        className="btn-icon btn-link like"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick(idx);
                        }}
                      >
                        <i className="tim-icons icon-simple-remove" />
                      </Button>
                    </div>
                  </td>
                </tr>
                {editingSellerTaxIndex === idx && (
                  <tr>
                    <td colSpan="11">
                      <Row>
                        <Col md="6">
                          <FormGroup>
                            <Label className="form-control-label">
                              Calc Type:
                            </Label>
                            <Select
                              activeColor={activeColor}
                              styles={selectStyles}
                              className="react-select"
                              name="calc_type"
                              value={
                                currentSellerTax.calc_type
                                  ? {
                                    value: currentSellerTax.calc_type,
                                    label: currentSellerTax.calc_type === 'registration' ? "Registration State" : "Contract State",
                                  }
                                  : null
                              }
                              onChange={(option) =>
                                setCurrentSellerTax((prev) => ({
                                  ...prev,
                                  calc_type: option?.value || "",
                                }))
                              }
                              options={[
                                { value: "registration", label: "Registration State" },
                                { value: "contract", label: "Contract State" },
                              ]}
                              placeholder="Select"
                              isClearable
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup>
                            <Label className="form-control-label">
                              Tax Category:
                            </Label>
                            <Select
                              activeColor={activeColor}
                              styles={selectStyles}
                              className="react-select"
                              name="category"
                              value={
                                currentSellerTax.category
                                  ? {
                                    value: currentSellerTax.category,
                                    label: currentSellerTax.category,
                                  }
                                  : null
                              }
                              onChange={(option) =>
                                setCurrentSellerTax((prev) => ({
                                  ...prev,
                                  category: option?.value || "",
                                }))
                              }
                              options={[
                                { value: "State Sales Tax", label: "State Sales Tax" },
                                { value: "County Sales Tax", label: "County Sales Tax" },
                                { value: "Inventory Tax", label: "Inventory Tax" },
                                { value: "City Sales Tax", label: "City Sales Tax" },
                              ]}
                              placeholder="Select"
                              isClearable
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <FormGroup>
                            {(!currentSellerTax.tax_variable || currentSellerTax.tax_variable === "0" || currentSellerTax.tax_variable === "Flat Tax - No Tax Variable") ? (
                              <>
                                <Label className="form-control-label">
                                  Flat Tax Amount:
                                </Label>
                                <DollarInput
                                  value={currentSellerTax.amount}
                                  onChange={(value) =>
                                    setCurrentSellerTax((prev) => ({
                                      ...prev,
                                      amount: value,
                                    }))
                                  }
                                  placeholder="$0.00"
                                />
                              </>
                            ) : (
                              <>
                                <Label className="form-control-label">Rate:</Label>
                                <PercentageInput
                                  name="tax_rate"
                                  value={currentSellerTax.tax_rate}
                                  onChange={(value) =>
                                    setCurrentSellerTax((prev) => ({
                                      ...prev,
                                      tax_rate: value,
                                    }))
                                  }
                                  placeholder="0.0000000%"
                                  maxValue={100}
                                />
                              </>
                            )}
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup>
                            <Label className="form-control-label">
                              Tax State:
                            </Label>
                            <StatesInput
                              name="tax_state"
                              activeColor={activeColor}
                              styles={selectStyles}
                              className="react-select"
                              value={currentSellerTax.state}
                              onChange={(stateObject) => {
                                setCurrentSellerTax((prev) => ({
                                  ...prev,
                                  state: stateObject
                                    ? {
                                      id: stateObject.id,
                                      abbreviation: stateObject.abbreviation,
                                    }
                                    : null,
                                }));
                              }}
                              placeholder="Select State"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <FormGroup>
                            <Label className="form-control-label">
                              Can Edit At Time Of Sale?:
                            </Label>
                            <Select
                              activeColor={activeColor}
                              styles={selectStyles}
                              className="react-select"
                              name="can_edit_at_time_of_sale"
                              value={
                                currentSellerTax.can_edit_at_time_of_sale !==
                                  null
                                  ? {
                                    value:
                                      currentSellerTax.can_edit_at_time_of_sale,
                                    label:
                                      currentSellerTax.can_edit_at_time_of_sale
                                        ? "Yes"
                                        : "No",
                                  }
                                  : null
                              }
                              onChange={(option) =>
                                setCurrentSellerTax((prev) => ({
                                  ...prev,
                                  can_edit_at_time_of_sale:
                                    option?.value ?? false,
                                }))
                              }
                              options={[
                                { value: false, label: "No" },
                                { value: true, label: "Yes" },
                              ]}
                              placeholder="Select"
                              isClearable={false}
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup>
                            <Label className="form-control-label">
                              Tax Fixed:
                            </Label>
                            <Select
                              activeColor={activeColor}
                              styles={selectStyles}
                              className="react-select"
                              name="fixed"
                              value={
                                currentSellerTax.fixed !== null
                                  ? {
                                    value: currentSellerTax.fixed,
                                    label: currentSellerTax.fixed
                                      ? "Yes"
                                      : "No",
                                  }
                                  : null
                              }
                              onChange={(option) =>
                                setCurrentSellerTax((prev) => ({
                                  ...prev,
                                  fixed: option?.value ?? false,
                                }))
                              }
                              options={[
                                { value: false, label: "No" },
                                { value: true, label: "Yes" },
                              ]}
                              placeholder="Select"
                              isClearable={false}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <FormGroup>
                            <Label className="form-control-label">
                              Tax Description:
                            </Label>
                            <Input
                              type="text"
                              value={currentSellerTax.description}
                              onChange={(e) =>
                                setCurrentSellerTax((prev) => ({
                                  ...prev,
                                  description: e.target.value,
                                }))
                              }
                              placeholder="Enter tax description"
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup>
                            <Label className="form-control-label">
                              Tax Variable:
                            </Label>
                            <Select
                              activeColor={activeColor}
                              styles={selectStyles}
                              className="react-select"
                              name="tax_variable"
                              value={
                                currentSellerTax.tax_variable
                                  ? {
                                    value: currentSellerTax.tax_variable,
                                    label: currentSellerTax.tax_variable,
                                  }
                                  : { value: "Flat Tax - No Tax Variable", label: "Flat Tax - No Tax Variable" }
                              }
                              onChange={(option) =>
                                setCurrentSellerTax((prev) => ({
                                  ...prev,
                                  tax_variable: option?.value || "Flat Tax - No Tax Variable",
                                }))
                              }
                              options={TAX_VARIABLE_OPTIONS}
                              placeholder="Select"
                              isClearable={false}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <FormGroup>
                            <Label className="form-control-label">
                              Tax Fixed:
                            </Label>
                            <Select
                              activeColor={activeColor}
                              styles={selectStyles}
                              className="react-select"
                              name="indicator"
                              value={
                                currentSellerTax.fixed !== null
                                  ? {
                                    value: currentSellerTax.fixed,
                                    label: currentSellerTax.fixed
                                      ? "Yes"
                                      : "No",
                                  }
                                  : null
                              }
                              onChange={(option) =>
                                setCurrentSellerTax((prev) => ({
                                  ...prev,
                                  fixed: option?.value ?? false,
                                }))
                              }
                              options={[
                                { value: false, label: "No" },
                                { value: true, label: "Yes" },
                              ]}
                              placeholder="Select"
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup>
                            <Label className="form-control-label">
                              Tax Range:
                            </Label>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <DollarInput
                                value={
                                  currentSellerTax.fixed
                                    ? "$0.00"
                                    : currentSellerTax.beginning_range
                                }
                                onChange={(value) =>
                                  setCurrentSellerTax((prev) => ({
                                    ...prev,
                                    beginning_range: value,
                                  }))
                                }
                                placeholder="$0.00"
                                disabled={currentSellerTax.fixed}
                              />
                              <span>To</span>
                              <DollarInput
                                value={
                                  currentSellerTax.fixed
                                    ? "$999,999.99"
                                    : currentSellerTax.end_range
                                }
                                onChange={(value) =>
                                  setCurrentSellerTax((prev) => ({
                                    ...prev,
                                    end_range: value,
                                  }))
                                }
                                placeholder="$0.00"
                                disabled={currentSellerTax.fixed}
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <FormGroup>
                            <Label className="form-control-label">
                              Rate Indicator:
                            </Label>
                            <Select
                              activeColor={activeColor}
                              styles={selectStyles}
                              className="react-select"
                              name="indicator"
                              value={
                                currentSellerTax.indicator
                                  ? {
                                    value: currentSellerTax.indicator,
                                    label: currentSellerTax.indicator,
                                  }
                                  : null
                              }
                              onChange={(option) =>
                                setCurrentSellerTax((prev) => ({
                                  ...prev,
                                  indicator: option?.value || "",
                                }))
                              }
                              options={[
                                { value: "fixed", label: "Fixed" },
                                { value: "dynamic", label: "Dynamic" },
                              ]}
                              placeholder="Select"
                              isClearable
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      {currentSellerTax.indicator === "fixed" && (
                        <>
                          <Row>
                            <Col md="6">
                              <FormGroup>
                                <Label className="form-control-label">
                                  Tax Rate:
                                </Label>
                                <PercentageInput
                                  name="tax_rate"
                                  value={currentSellerTax.tax_rate}
                                  onChange={(value) =>
                                    setCurrentSellerTax((prev) => ({
                                      ...prev,
                                      tax_rate: value,
                                    }))
                                  }
                                  placeholder="0.0000000%"
                                  maxValue={1000}
                                />
                              </FormGroup>
                            </Col>
                            <Col md="6">
                              <FormGroup>
                                <Label className="form-control-label">
                                  Flat Tax Amount:
                                </Label>
                                <DollarInput
                                  value={currentSellerTax.amount}
                                  onChange={(value) =>
                                    setCurrentSellerTax((prev) => ({
                                      ...prev,
                                      amount: value,
                                    }))
                                  }
                                  placeholder="$0.00"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </>
                      )}
                      <Row>
                        <Col className="text-right">
                          <Button
                            color="secondary"
                            size="sm"
                            onClick={handleCancelSellerTax}
                            style={{ marginRight: "10px" }}
                          >
                            Cancel
                          </Button>
                          <Button
                            size="sm"
                            style={{ ...activeColorStyle, color: "white" }}
                            onClick={handleAddSellerTax}
                          >
                            Update
                          </Button>
                        </Col>
                      </Row>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </Table>
      )}

      {/* Delete Confirmation Modal */}
      <Modal
        isOpen={deleteModalOpen}
        toggle={handleCancelDelete}
        centered={false}
        style={{ marginTop: "100px" }}
      >
        <div className="modal-header justify-content-center">
          <button
            aria-hidden={true}
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={handleCancelDelete}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
          <h6 className="title title-up">Delete Seller Tax</h6>
        </div>
        <ModalBody className="text-center">
          <p>Are you sure you want to delete this seller tax?</p>
        </ModalBody>
        <div className="modal-footer">
          <Button
            color="secondary"
            type="button"
            onClick={handleCancelDelete}
            disabled={updateSalesLocationMutation.isPending}
          >
            Cancel
          </Button>
          <Button
            style={{
              background:
                "linear-gradient(to bottom left, #fd5d93, #ec250d, #fd5d93)",
              backgroundImage:
                "linear-gradient(to bottom left, #fd5d93, #ec250d, #fd5d93)",
              borderColor: "#fd5d93",
              color: "white",
            }}
            color="danger"
            type="button"
            onClick={handleConfirmDelete}
            disabled={updateSalesLocationMutation.isPending}
          >
            {updateSalesLocationMutation.isPending ? (
              <>
                <span
                  className="spinner-border spinner-border-sm mr-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Deleting...
              </>
            ) : (
              "Yes, Delete"
            )}
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default SellerTaxes;
